import React, { useEffect, useState } from "react";//added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  getCpSmList
} from "reduxStore/action/channelPartnerAction";
import { getSourcingManagerList} from '../../reduxStore/action/sourcingManagerAction'
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import { channelPartnerUserType } from "utils/constants";
import usePage from "utils/usePage";
import moment from "moment";
import Select from "react-select";
import Button from "component/Button";
import { cpCurrentMaping } from "../../reduxStore/action/channelPartnerAction";
import AllocateProperty from "../../component/common/AllocateProperty"
import apiEndPoints from "utils/apiEndPoints";
import { apiCall, errorToast, successToast } from "utils/httpClient";

const CpSmList = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formState, setFormState] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); 
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [currentCPMaping, setCurrentCPMaping] = useState([]);
  const [tlList, setTlList] = useState([]);
  const [smList, setSmList] = useState([]);
const [sourcingManagerList, setSourcingManagerList] = useState([]);
const [selectedSourcingManager, setSelectedSourcingManager] = useState(null);
  const [isManagerSelection, setManagerSelection] = useState(false); // To track the manager selection step
  const channelPartnerListSelector = useSelector(
    (state) => state?.cpSmData
  );


    const permissionSelector = useSelector((state) => state.permission);
    const {  isAdmin = false } = permissionSelector;

    const {response:res} = useSelector((state) => state.login)

      const sourcingManagerSelecter = useSelector(
        (state) => state?.smData
      );

    // const [modalShow, setModalShow] = useState(false);
    // const [selectedCpId, setSelectedCpId] = useState("");
    
      
    //     const handleAllocateClick = (cp_id) => {
    //       setModalShow(true); // Show the modal
    //       setSelectedCpId(cp_id)
    //     };
      
        
    
    //     const handleCloseModal = () => {
          
    //         setModalShow(false);
    //         setSelectedCpId("")
    //       };


    //       const [showModal, setShowModal] = useState(false); // Modal visibility state
    //       const [selectedItem, setSelectedItem] = useState(null); // Store the selected item for confirmation
        
    //       // Function to handle the button click (show modal with action)
    //       const handleButtonClick = (item, action) => {
    //         setSelectedItem(item); // Set the selected item for confirmation
    //         setShowModal(true); // Show the modal
    //       };
        
    //       // Function to handle confirmation of the action
    //       const handleConfirm = () => {
    //         if (selectedItem) {
    //           activeDeactive(selectedItem._id, selectedItem.active_status ? true : false,selectedItem?.total_visit); // Call the activeDeactive function
    //           setShowModal(false); // Close the modal
    //         }
    //       };
        
    //       // Function to handle modal cancel
    //       const handleCancel = () => {
    //         setShowModal(false); // Close the modal without any action
    //       };  

    //       const activeDeactive = async (user_id, active_status,isLead) => {

    //         if(isLead===0){
    //         const params = {
    //           user_id,       // The ID of the user/channel partner
    //           status: 2,     // Status is always 2 as per your requirement
    //           active_status  // Current active_status value from the item
    //         };
          
    //         try {
    //           const response = await apiCall("post", apiEndPoints.SMCHANNELPARTNERSTATUS, params);
    //           if (response?.data?.status === 200) {
    //             // Handle successful response (e.g., show a success message)
    //             successToast(response?.data?.message);
    //             dispatch(
    //               getAssignCPList({
    //                 user_id: res?.data?._id,
    //                 limit: 10,
    //                 offset: page,
    //                 // role_id: roleId,
    //               })
    //             )
    //             // Optionally, trigger a state update to reflect the changes in UI
    //           } else {
    //             errorToast(response?.data?.message);
    //           }
    //         } catch (error) {
    //           console.error("Error calling API:", error);
    //         }
    //       }else{
    //         const params = {
    //           user_id,       // The ID of the user/channel partner   
    //           active_status  // Current active_status value from the item
    //         };
          
    //         try {
    //           const response = await apiCall("post", apiEndPoints.TRANSFERCHANELPARTNERSTATUS, params);
    //           if (response?.data?.status === 200) {
    //             // Handle successful response (e.g., show a success message)
    //             successToast(response?.data?.message);
    //             dispatch(
    //               getAssignCPList({
    //                 user_id: res?.data?._id,
    //                 limit: 10,
    //                 offset: page,
    //                 // role_id: roleId,
    //               })
    //             )
    //             // Optionally, trigger a state update to reflect the changes in UI
    //           } else {
    //             errorToast(response?.data?.message);
    //           }
    //         } catch (error) {
    //           console.error("Error calling API:", error);
    //         }
    //       }
    //       };

  const params = new URLSearchParams(window.location.search);
  const roleId = params.get("role_id");
  const userType = params.get("user_type")
    ? params.get("user_type")
    : channelPartnerUserType.cp;

  const { create, view,edit } = usePermission({
    create: "add_channelpartner",
    view: "view_channelpartner",
    edit:"edit_channelpartner"
  });

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    if(!isAdmin){
    dispatch(
      getCpSmList({})
    );
  }
  }, [dispatch, isAdmin]);

 
  useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;
    if (response && response?.status === 200) {

      if (!create && response.data?.length > 0) {
        setchannelPartnerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      } else {
        if(!isAdmin){
            dispatch(
              getCpSmList({})
            );
          }
      }
    } else {
      setchannelPartnerList([]);
    }
  }, [channelPartnerListSelector, dispatch, isAdmin]);

   useEffect(() => {
       const { response = null, create = false } = sourcingManagerSelecter;
       if (response && response?.status === 200) {
   
         if (!create && response.data?.length > 0) {
           setSourcingManagerList(
             handleListResponse(response?.data) ? response?.data : []
           );
         }
       } else {
         setSourcingManagerList([]);
       }
     }, [sourcingManagerSelecter]);


const handleApprove = async (item) => {
    // Prepare parameters for the API call
    const params = {
      cp_id: [item._id],
      property_id: item.property_id,
      assign_type: 2,
      user_id: selectedSourcingManager
    };
  
    try {
      // Make the API call
      const response = await apiCall("post", apiEndPoints.CPASSIGNSOURCINGMANAGER, params);
  
      // Handle successful response
      if (response?.data?.status === 200) {
        successToast(response?.data?.message); // Show success message
        dispatch(getCpSmList({})); // Fetch the updated list of CP-SM associations
      } else {
        // Handle error response
        errorToast(response?.data?.message); // Show error message
      }
    } catch (error) {
      // Handle any errors during the API call
      errorToast(error);
    }
  
    setSelectedItem([]);
    setSelectedSourcingManager(null)
    // Close modal after the operation
    setModalOpen(false);
  };

  const openApprovalModal = (item) => {
    setSelectedItem(item);
    dispatch(getSourcingManagerList({property_id:item.property_id}))
    setModalOpen(true); // Open modal when Approve button is clicked
  };

  const closeApproveModal=()=>{
    setSelectedItem([]);
    setSelectedSourcingManager(null)
    setModalOpen(false);
  }

  

  





  

  // Disable end_date


  useEffect(() => {
    seo({
      title: "Channel Parnter Listing",
      metaDescription: "Channel partner listing",
      canonicalLink: window.location.href,
    });
  }, []);


  return (
    <div className="page-body">
      {/* Model_start */}
     
      {/* Model_end */}
      <Breadcrumb
        title={strings.allocateCpToSm}
        titleactive={strings.channelPartner}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
          
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div  className="card-header">
                    <h5>{strings.listOfChannelPartner}</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table table-border-horizontal">
                    <thead className="text-center">
                        <tr>
                        <th scope="col">{strings.agencyName}</th>
                        <th scope="col">{strings.propertyName}</th>
                        <th scope="col">{strings.location}</th>
                        <th scope="col">{strings.reraNo}</th>
                        <th scope="col">{strings.totalVisits}</th>
                        <th scope="col">{strings.noOfSiteVisits}</th>
                        <th scope="col">{strings.noBookings}</th>
                        <th scope="col">{strings.status}</th>
                        <th scope="col" style={{ width: "200px" }}>{strings.action}</th> {/* Wider action column */}
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {getchannelPartnerList?.length > 0 ? (
                        getchannelPartnerList.map((item, index) => {
                            return (
                            <tr key={index}>
                                <td style={{ inlineSize: "130px" }}>
                                {item?.agent_name}
                                </td>
                                <td>
                                {item.property_title}
                                </td>
                                <td>{item.location}</td>
                                <td>{item.rera_certificate_no}</td>
                                <td>{item.total_visit}</td>
                                <td>{item.total_site_visit}</td>
                                <td>{item.total_closing_lead}</td>
                                <td>
                                {item.active_status ? strings.active : strings.deactive}
                                </td>
                                <td className="p-2" style={{ whiteSpace: "nowrap" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    {view && (
                                    <i
                                        className="fa fa-eye theme-fa-icon p-2"
                                        aria-hidden="true"
                                        title={strings.viewChannelPartner}
                                        onClick={() => {
                                        const navigateTo = isAdmin ? `/viewchannelpartner/${item._id}` : `/viewchannelpartner/${item.cp_id}`;
                                        navigatpage(navigateTo);
                                        }}
                                        style={{ cursor: "pointer", marginRight: "10px" }}
                                    ></i>
                                    )}

                                    {edit && !isAdmin && (
                                    <button
                                        type="button"
                                        onClick={() => openApprovalModal(item)}
                                        className="btn-sm mt-1"
                                        style={{
                                        color: "green", // Green for active, red for deactivated
                                        borderColor: "green", // Same logic for border color
                                        backgroundColor: "white",
                                        display: "inline-block", // Display inline for side-by-side buttons
                                        }}
                                    >
                                        {strings.allocate}
                                    </button>
                                    )}
                                </div>
                                </td>
                            </tr>
                            );
                        })
                        ) : (
                        <tr />
                        )}
                    </tbody>
                    </table>

                    <TableDataNotFound data={getchannelPartnerList} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            {isModalOpen && !isManagerSelection && (
        <div
          className="modal fade show"
          style={{ display: 'block', backdropFilter: 'blur(5px)' }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="approveModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="approveModalLabel">Confirmation</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>Are you sure you want to allocate sm to this CP?</h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
              <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => setManagerSelection(true)}
                  data-dismiss="modal"
                >
                  Yes
                </button>
                <button
                  className="btn btn-primary "
                  type="button"
                  onClick={() => closeApproveModal()}
                  data-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{isModalOpen && isManagerSelection && (
        <div
          className="modal fade show"
          style={{ display: 'block', backdropFilter: 'blur(5px)' }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="approveModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="approveModalLabel">
                  Confirmation
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>Select a Sourcing Manager</h6>
                  <select
                    className="form-control"
                    value={selectedSourcingManager}
                    onChange={(e) => setSelectedSourcingManager(e.target.value)}
                  >
                    <option value="" disabled>
                      Select a Sourcing Manager
                    </option>
                    {sourcingManagerList.map((manager) => (
                      <option key={manager._id} value={manager._id}>
                        {manager.user_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => handleApprove(selectedItem)} // Confirm allocation with the selected sourcing manager
                >
                  Confirm
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => closeApproveModal()} // Close modal
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{/* {showModal && (
        <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
          backdropFilter: "blur(5px)", // Background blur effect
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
          }}
        >
            <div className="modal-content">
<div className="modal-header">
              <h5 className="modal-title">Confirm Action</h5>
              <button type="button" className="close" onClick={handleCancel}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to {selectedItem.active_status?"Deactivate":"Activate"} the channel partner?
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirm}
              >
                Confirm
              </button>
            </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};
export default CpSmList;
